import { SpinnerCenter } from "@shapr3d/frontend-lib";
import { Navigate, Outlet, useParams } from "react-router-dom";

import { useTeam } from "../../hooks/useTeams";

export const TeamOwnerLayout: React.FC = () => {
  const { teamID } = useParams();
  const { teamData, isOwner } = useTeam(teamID);

  if (!teamData) {
    return <SpinnerCenter />;
  }

  if (!isOwner) {
    return <Navigate to={`/teams/${teamID}`} />;
  }

  return <Outlet />;
};
